import { LlmConversation, LlmConversationHeaderMultiMenuController, LlmConversationMenuController } from '@adaptiva/ai/common';
import { SelectionManagerService } from '@adaptiva/core/collections';
import { DynamicOverlay, OverlayService } from '@adaptiva/core/overlays';
import { UiService } from '@adaptiva/core/ui';
import { EJavaClassNames, IObjectTableListConfiguration, ObjectNameDisplayService } from '@adaptiva/data-service';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { ObjectTableComponent, ObjectTableComponentModule } from '@adaptiva/widgets/object-table';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal, Signal, viewChild, WritableSignal } from '@angular/core';
import { Subject } from 'rxjs';
import { ILlmConversationOverlayContext } from './llm-conversation-overlay-context.interface';

@Component({
	selector: 'ada-llm-conversation-overlay',
	templateUrl: './llm-conversations-overlay.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		ObjectTableComponentModule,
		MenuComponentModule,
	],
	providers: [
		LlmConversationMenuController,
		LlmConversationHeaderMultiMenuController,
		SelectionManagerService
	]
})
export class LlmConversationOverlayComponent extends DynamicOverlay<ILlmConversationOverlayContext> implements OnInit {

	protected readonly objectTable: Signal<ObjectTableComponent> = viewChild(ObjectTableComponent);

	protected readonly queryConfig: WritableSignal<IObjectTableListConfiguration> = signal(null);

	protected readonly objectNameDisplayService: ObjectNameDisplayService = inject(ObjectNameDisplayService);

	protected readonly ui: UiService = inject(UiService);

	protected readonly overlayService: OverlayService = inject(OverlayService);

	public override readonly submit: Subject<boolean> = new Subject();

	protected readonly menuController: LlmConversationMenuController = inject(LlmConversationMenuController);

	protected readonly menuHeaderController: LlmConversationHeaderMultiMenuController = inject(LlmConversationHeaderMultiMenuController);

	constructor() {
		super({
			id: EJavaClassNames.LlmConversation,
			cancelText: 'Close',
			clickoutEnabled: true,
			showConfirmButton: false
		});
	}

	protected setSelections(_items: LlmConversation[]): void {
		if (!_items?.length)
			this.result = [];
		else
			this.result = [..._items];
	}

	public emitSubmission(_isSubmitted: boolean): void {
		this.submit.next(_isSubmitted);
	}

	public ngOnInit(): void {
		this.ready.next(true);

		if (this.context) {
			this.title = this.context.title;
			this.queryConfig.set(this.context.queryConfig);
		}
	}

	public override open(_context?: ILlmConversationOverlayContext): void {
		super.open(_context);
		this.overlayService.add(this);
	}

	public override close(_isSubmitted?: boolean): void {
		super.close(_isSubmitted);
		this.overlayService.remove(this);
	}

}
